"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Currency = require("../../records/Currency");
var _getCandidate = _interopRequireDefault(require("./services/getCandidate"));
var _filterCurrencies = _interopRequireDefault(require("./services/filterCurrencies"));
var _getRecommended = _interopRequireDefault(require("./services/getRecommended"));
var _resolveCurrency = _interopRequireDefault(require("./services/resolveCurrency"));
const init = _ref => {
  let {
    currencies,
    initialCurrency,
    countryCurrency,
    languageCurrency,
    affiliate,
    brandCurrencies,
    mostUsedCurrencies = _Currency.MOST_USED_CURRENCIES
  } = _ref;
  const candidate = (0, _getCandidate.default)({
    initial: initialCurrency,
    country: countryCurrency,
    lang: languageCurrency
  });
  const available = (0, _filterCurrencies.default)(affiliate, brandCurrencies, currencies);
  const recommended = (0, _getRecommended.default)(countryCurrency, languageCurrency, mostUsedCurrencies, available);
  return {
    currency: (0, _resolveCurrency.default)(currencies, available, candidate),
    available,
    recommended
  };
};
var _default = exports.default = init;